export const iconFontAwesomeArrowsAngleRight = (
	<i className="fa-solid fa-angle-right"></i>
);
